<template>
  <content-loader
    :height="435"
    :width="600"
    preserveAspectRatio="xMidYMin slice"
  >
    >
    <rect x="132.5" y="10" rx="5" ry="5" width="335" height="126" />
    <rect x="132.5" y="156" rx="5" ry="5" width="335" height="126" />
    <rect x="132.5" y="302" rx="5" ry="5" width="335" height="126" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
